module.exports = __webpack_public_path__ + "static/media/secong-img-news.effa2941.png";